import React, { useState, useEffect } from 'react'
import uploadApi from '_api/upload'
import { SHIFT_DOWN, SHIFT_UP } from '_utils/constant'
import noImage from '_images/noimage02.svg'
import InputProduct from '../../../pages/Event/components/InputProduct'
import '../style.scss'

const DesktopProductItemIndividual = (props) => {
  const {
    productIndex,
    product,
    totalListProduct,
    register,
    swapProduct,
    setValue,
    errors
  } = props

  const [splitCasePhotoUrl, setSplitCasePhotoUrl] = useState(
    product?.splitCasePurchase?.photoUrl || product?.photoUrls?.[0] || ''
  )

  useEffect(() => {
    if (product?.splitCasePurchase?.photoUrl || product?.photoUrls?.[0]) {
      setSplitCasePhotoUrl(product?.splitCasePurchase?.photoUrl || product?.photoUrls?.[0] || '')
    }
  }, [product?.splitCasePurchase?.photoUrl, product?.photoUrls, product?.splitCasePurchase])

  useEffect(() => {
    if (
      product?.splitCasePurchase &&
      (!product?.splitCasePurchase?.name || product?.splitCasePurchase?.name === '')
    ) {
      setValue(`products.${productIndex}.splitCasePurchase.name`, product?.name || '')
    }
  }, [product?.splitCasePurchase, product?.name, productIndex, setValue])

  const onSplitCaseImageUploaded = async (event) => {
    const { files } = event.target
    if (files && files[0]) {
      const img = files[0]
      const { msgResp } = await uploadApi.uploadPhoto([img])
      setSplitCasePhotoUrl(URL.createObjectURL(img))
      setValue(`products.${productIndex}.splitCasePurchase.photoUrl`, msgResp.url)
    }
  }
  const handleDescriptionChange = (e) => {
    let { value } = e.target;
    value = value.replace(/\n{3,}/g, '\n\n');
    setValue(`products.${productIndex}.splitCasePurchase.description`, value);
  };
  const removeSplitCaseImage = () => {
    setSplitCasePhotoUrl('')
    setValue(`products.${productIndex}.splitCasePurchase.photoUrl`, '')
  }

  const handleChangeSequence = (index, direction) => {
    if (index - 1 >= 0 && direction === SHIFT_UP) {
      swapProduct(index, index - 1)
    }
    if (index + 1 < totalListProduct && direction === SHIFT_DOWN) {
      swapProduct(index, index + 1)
    }
  }

  if (!product?.splitCasePurchase) {
    return null
  }

  return (
    <div>
      <div className='detail-list-news__item detail-list-news__item--background'>
        <div className='c-form'>
          <div className='row' style={{ flexWrap: 'nowrap' }}>
            <label className='col-sm-3 col-2 align-self-center'>Item Image</label>
            <div className='col-sm-9 col-10'>
              <div className='desktop-product-item__image-upload mt-3 mb-3'>
                <div className='desktop-product-item__image-box'>
                  <img src={splitCasePhotoUrl || noImage} alt='product' />
                  <div className='desktop-product-item__image-overlay'>
                    <input
                      type='file'
                      accept='image/*'
                      className='desktop-product-item__image-input'
                      value=''
                      onChange={onSplitCaseImageUploaded}
                    />
                  </div>
                </div>
                {splitCasePhotoUrl && (
                  <span className='desktop-product-item__image-remove' onClick={removeSplitCaseImage}>
                    &times;
                  </span>
                )}
              </div>
            </div>
          </div>
          <div className='row mt-0'>
            <label className='col-sm-3 col-2 align-self-center'>Item name</label>
            <div className='col-sm-9 col-10'>
              <div>
                <span className='c-txt-org' style={{ fontSize: '14px' }}>
                  Individual Pieces (Split Case)
                </span>
              </div>
              <InputProduct
                register={register(`products.${productIndex}.splitCasePurchase.name`)}
                defaultValue={product?.name || ''}
                className={`form-control ${
                  errors?.products &&
                  Object.entries(errors?.products).length !== 0 &&
                  errors?.products?.[productIndex]?.name &&
                  'is-error'
                }`}
                error={errors?.products?.[productIndex]?.splitCasePurchase?.name?.message}
              />
            </div>
          </div>
          {product?.splitCasePurchase && (
            <div className='row'>
              <label className='col-sm-3 col-2 align-self-center'>Description</label>
              <div className='col-sm-9 col-10'>
                <textarea
                  className={`form-control custom-scrollbar ${
                    errors?.products &&
                    Object.entries(errors?.products).length !== 0 &&
                    errors?.products[productIndex]?.splitCasePurchase?.description &&
                    'is-error'
                  }`}
                  rows={3}
                  placeholder='(Optional)'
                  {...register(`products.${productIndex}.splitCasePurchase.description`)}
                  onChange={handleDescriptionChange}
                />
              </div>
            </div>
          )}
          <div className='row row-price'>
            <label className='col-sm-3 col-2 align-self-start'>Price ($)</label>
            <div className='col-sm-9 col-10'>
              <InputProduct
                type='number'
                className={`form-control ${
                  errors?.products &&
                  Object.entries(errors?.products).length !== 0 &&
                  errors?.products[productIndex]?.splitCasePurchase?.costPerItem &&
                  'is-error'
                }`}
                register={register(`products.${productIndex}.splitCasePurchase.costPerItem`)}
                step='0.01'
                error={errors?.products?.[productIndex]?.splitCasePurchase?.costPerItem?.message}
              />
              <div className='btn-action'>
                <a
                  className='btn-remove'
                  onClick={() => {
                    setValue(`products.${productIndex}.splitCasePurchase`, null)
                  }}
                />
              </div>
            </div>
          </div>
        </div>
        <div
          className='arrow-drap arrow-drap-up'
          onClick={() => handleChangeSequence(productIndex, SHIFT_UP)}
        />
        <div
          className='arrow-drap arrow-drap-down'
          onClick={() => handleChangeSequence(productIndex, SHIFT_DOWN)}
        />
      </div>
    </div>
  )
}

export default DesktopProductItemIndividual
